import { render } from "./HeaderPage.vue?vue&type=template&id=6a45b015&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=6a45b015&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a45b015"]])

export default __exports__